import React from "react";
import {CustomTextAreaWrapper, TextAreaIconWrapper} from "./input.styles";

const CustomTextArea = ({label, classNames, labelStyle, subLabel = '', icon: Icon, ...otherProps}) => {
    return (
        <CustomTextAreaWrapper className={classNames} inputValue={otherProps.value}>
            <label className={labelStyle ? labelStyle : 'mb-3'}>{label}{subLabel && <span>{subLabel}</span>}</label>
            <textarea {...otherProps}>

            </textarea>
            {
                Icon && <TextAreaIconWrapper>{Icon}</TextAreaIconWrapper>
            }
        </CustomTextAreaWrapper>
    );
};

export default CustomTextArea;
